import * as actionTypes from "../../Constants/customFieldActionTypes";
const initialState = {
    firmCustomFields: [],
    originalFirmCustomFields:[],   
    isCustomFieldEdited: false,
    isDdlOptionsChanged: false,
    isCustomFieldLoading:false
    
}

const customFieldsReducer = (state = initialState, action) => {
    switch (action.type){
        case actionTypes.FETCH_ALL_CUSTOM_FILEDS:
            return {
                ...state,
                firmCustomFields: action.payload.allCustomFields,
                originalFirmCustomFields: JSON.stringify(action.payload.allCustomFields)
            }
        case actionTypes.CUSTOM_FIELD_EDITED:
            return {
                ...state,
                isCustomFieldEdited:action.payload.isCustomFieldEdted
            }
        case actionTypes.CUSTOM_FIELD_RESET: {
            let originalCustomFields;
            try {
                originalCustomFields = JSON.parse(action.payload.originalCustomFields);
            }
            catch (error) {
                console.error('Invalid JSON input:', error.message);
            }
            return {
                ...state,
                isCustomFieldEdited: false,
                firmCustomFields: originalCustomFields,
                //originalFirmCustomFields:action.payload.originalCustomFields                
            }
        }
        case actionTypes.CUSTOM_FIELD_SAVE:
            return {
                ...state,
                firmCustomFields: action.payload.editedCustomFields,
                originalFirmCustomFields: JSON.stringify(action.payload.editedCustomFields),
                isCustomFieldEdited: false,
            }
        
        case actionTypes.SAVE_DROPDOWN_OPTIONS:
            return {
                ...state,
                firmCustomFields: action.payload.all,
                originalFirmCustomFields:JSON.stringify(action.payload.orginal)
                
            }
            case actionTypes.LOADING:
                return {
                    ...state,
                   isCustomFieldLoading:action.payload.isloading
                    
                }
        default :
            return state
    }
}

export default customFieldsReducer;